function collapseOpen() {
    var vars = [], hash;
    var collapse = "";
    var newScrollTop = 0;
    var NativeQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // QueryString okunur
    var getQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&'); // QueryString okunur ve Split eder

    if (NativeQueryFilter.indexOf("=") != "-1") {
        for (var i = 0; i < getQueryFilter.length; i++) {
            hash = getQueryFilter[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];

            if (hash[0] == "open") {
                collapse = hash[1]; // collapse değerleri alınır
            }
        }
    }
    if (collapse != null && collapse != undefined && collapse != "") {
        if ($("#" + collapse).length > 0) {
            $("#" + collapse).collapse("show");
            newScrollTop = $("#" + collapse).offset().top;
            $('html, body').animate({
                scrollTop: newScrollTop - 350
            }, 0);
        }
    }
}

$(document).ready(function () {
    var cName = $("#CName").val();
    $(".bedenIcons div").live("click", function () {
          
        var el = this; 
        var id = $(el).attr("data-type");
          
        $("#ceket").css("display", "none");
        $("#tshirt").css("display", "none");
        $("#pantolon").css("display", "none");
        $("#gomlek").css("display", "none");
        $("#triko").css("display", "none");
        $("#disgiyim").css("display", "none");
        $(".bedenContent  #" + id).css("display", "inherit");
       
    });

    
    if (cName != null && cName != undefined && cName == "ContentPg") {
        collapseOpen();
    }    
});